import Loadable from 'react-loadable';

import { trackException } from 'utils/errorLogging';

import { PHOSPHOR_ICONS } from '../constants/iconRegistry';

const MissingIcon = PHOSPHOR_ICONS.ImageSquare;

export const LazyPhosphorIcon = Loadable({
  loader: () =>
    import('phosphor-react').catch((error) => {
      trackException(error, {
        level: 'error',
        extra: { chunk: 'PhosphorIcons' },
        tags: undefined,
      });
      return {};
    }),
  loading: () => null,
  render(loaded, { icon, phosphorIconName, ...props }) {
    const { [phosphorIconName]: IconComponent } = loaded;

    if (IconComponent) return <IconComponent {...props} />;

    if (
      process.env.NODE_ENV !== 'production' &&
      typeof window !== 'undefined'
    ) {
      window.console.error(
        `>>>>>>> Missing Icon: ${icon}, path: ${window.location.pathname}`
      );
    }
    return <MissingIcon {...props} />;
  },
});
